import { parsePhoneNumber } from "libphonenumber-js";

export const phoneNumberFormatE164 = (
  number: string | undefined | null
): string | undefined | null => {
  try {
    if (!number) return number;

    const phoneNumber = parsePhoneNumber(number, "US");
    if (phoneNumber?.isValid()) {
      return phoneNumber.number;
    } else {
      return number;
    }
  } catch (error) {
    return number;
  }
};
